import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconHide16pxRegular = function IconHide16pxRegular(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 16 16",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.988 1.244c.293.293.276.784-.037 1.097L2.333 12.959c-.313.313-.804.329-1.097.036-.293-.293-.276-.784.037-1.097L11.89 1.28c.313-.313.804-.33 1.097-.036z"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 14c4.518 0 6.768-3.403 7.604-5.083.29-.582.29-1.252 0-1.834-.431-.867-1.24-2.195-2.544-3.275l-1.831 1.83a4 4 0 01-5.59 5.59l-1.683 1.684C5.036 13.557 6.37 14 8 14zm-4.972-1.736l1.812-1.812a4 4 0 015.613-5.613l1.69-1.69C11.048 2.47 9.68 2 8 2 3.481 2 1.231 5.403.396 7.083a2.046 2.046 0 000 1.834c.441.887 1.276 2.254 2.632 3.347zm5.988-5.987a2 2 0 00-2.739 2.739l2.739-2.74zM7.087 9.78A2 2 0 009.78 7.087L7.087 9.78z"
    })]
  }));
};
export default IconHide16pxRegular;